import { LinearProgress } from '@patrianna/core-components'

import useCountdown from 'src/hooks/useCountdown'

import classes from './styles.module.scss'

const ONE_HUNDRED_PERCENT = 100
const THIRTY_SECONDS = 30000

export default function CountdownBar({ nextGameStart }: { nextGameStart: number }) {
  const countdown = useCountdown(nextGameStart, 100)

  const progress =
    countdown <= THIRTY_SECONDS ? (countdown * ONE_HUNDRED_PERCENT) / THIRTY_SECONDS : ONE_HUNDRED_PERCENT

  if (countdown) {
    return (
      <div className={classes.root}>
        <LinearProgress className={classes.progress} barClassName={classes.progressColor} value={progress} />
      </div>
    )
  }

  return null
}
